import { TabsItem } from './TabsItem';
import "./sass/tabs.css";

export const Tabs = ({handleChangeTab, dataContent}) => {
  return (
    <ul className="nav nav-tabs tabs" role="tablist">
      {
        dataContent.map( (tabItem,index) => (
          tabItem.visible ?
          <TabsItem name={tabItem.name} id={tabItem.id} active={tabItem.active} key={`tb${index}-${tabItem.key}`} handleChangeTab={handleChangeTab}  /> 
          :<div className='none' key={`dv${index}-${tabItem.key}`}/>
        ))
      }
    </ul>
  );
};